import { render, staticRenderFns } from "./addSchoolKeywordDialog.vue?vue&type=template&id=4c169761&scoped=true&"
import script from "./addSchoolKeywordDialog.vue?vue&type=script&lang=js&"
export * from "./addSchoolKeywordDialog.vue?vue&type=script&lang=js&"
import style0 from "./addSchoolKeywordDialog.vue?vue&type=style&index=0&id=4c169761&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c169761",
  null
  
)

export default component.exports